/**
 * 图形验证码
 */
import { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { userApi } from "@/api/modules/user";

interface CaptchaProps {
  onValidate?: (valid: boolean) => void;
}

export interface CaptchaRef {
  validate: (code: string) => Promise<boolean>;
  refresh: () => void;
  getUuid: () => string | null;
}

const Captcha = forwardRef<CaptchaRef, CaptchaProps>(({ onValidate }, ref) => {
  const [captchaData, setCaptchaData] = useState<{ uuid: string; img: string } | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchCaptcha = async () => {
    try {
      setLoading(true);
      const response = await userApi.getCaptcha();
      console.log("验证码API返回数据:", response);
      console.log("UUID:", response?.data.uuid);
      console.log("Image数据长度:", response?.data.img?.length);
      console.log("Image前50字符:", response?.data.img?.substring(0, 50));
      setCaptchaData(response?.data);
    } catch (error) {
      console.error("获取验证码失败:", error);
    } finally {
      setLoading(false);
    }
  };

  useImperativeHandle(ref, () => ({
    validate: async (code: string) => {
      if (!captchaData || !code.trim()) {
        return false;
      }
      try {
        const response = await userApi.verifyCaptcha({
          uuid: captchaData.uuid,
          code: code.trim()
        });
        const isValid = response.valid;
        if (onValidate) {
          onValidate(isValid);
        }
        return isValid;
      } catch (error) {
        console.error("验证验证码失败:", error);
        if (onValidate) {
          onValidate(false);
        }
        return false;
      }
    },
    refresh: () => {
      fetchCaptcha();
    },
    getUuid: () => {
      return captchaData?.uuid || null;
    }
  }));

  useEffect(() => {
    fetchCaptcha();
  }, []);

  return (
    <div className="flex items-center space-x-3">
      {captchaData && (
        <img
          src={`data:image/png;base64,${captchaData.img}`}
          alt="验证码"
          className="border border-gray-300 rounded cursor-pointer h-[50px] w-[160px]"
          onClick={fetchCaptcha}
        />
      )}
      {/*<Button*/}
      {/*  type="button"*/}
      {/*  variant="outline"*/}
      {/*  size="icon"*/}
      {/*  onClick={fetchCaptcha}*/}
      {/*  disabled={loading}*/}
      {/*  title="刷新验证码"*/}
      {/*>*/}
      {/*  <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />*/}
      {/*</Button>*/}
    </div>
  );
});

Captcha.displayName = "Captcha";

export default Captcha;
